import { render } from "./AssistenzaWiperWC.ce.vue?vue&type=template&id=302bf661"
import script from "./AssistenzaWiperWC.ce.vue?vue&type=script&lang=js"
export * from "./AssistenzaWiperWC.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__